import {
  PressEvent,
  Rows2Icon,
  Spacer,
  Text,
  UnstyledButton,
} from '@sparemin/blockhead';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createLayoutSegmentByIdSelector } from 'redux/modules/embed/selectors';
import { pushModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { useTrackAssetContext } from '../../components/TrackAsset';
import { block, millisToPosition } from '../../utils';
import { createSegmentDisplayNameSelector } from './selectors';

export type FramingSegmentProps = {
  id: string;
  isActive?: boolean;
};

function FramingSegment(props: FramingSegmentProps): React.ReactElement | null {
  const { id: segmentId, isActive } = props;

  const dispatch = useDispatch<Dispatch>();

  const { id: videoId, pxPerSec } = useTrackAssetContext();

  const segment = useSelector(
    useMemo(() => createLayoutSegmentByIdSelector(videoId, segmentId), [
      segmentId,
      videoId,
    ]),
  );

  const segmentDisplayName = useSelector(
    createSegmentDisplayNameSelector(videoId, segmentId),
  );

  const handlePress = useCallback(
    (e: PressEvent) => {
      if (e.pointerType === 'keyboard') {
        return;
      }

      dispatch(
        pushModal({ name: 'EditScene', params: { videoId, segmentId } }),
      );
    },
    [dispatch, videoId, segmentId],
  );

  return (
    <UnstyledButton
      as="div"
      className={block('autoframed-video-asset-framing-timeline-segment', {
        isActive,
      })}
      onPress={handlePress}
      style={{
        width: millisToPosition(segment.durationMillis, pxPerSec),
      }}
    >
      <Spacer
        align="center"
        className={block(
          'autoframed-video-asset-framing-timeline-segment-contents',
        )}
        orientation="horizontal"
        space="2px"
      >
        <Rows2Icon />
        <Text variant="adornment" letterSpacing={1.5}>
          {segmentDisplayName}
        </Text>
      </Spacer>
    </UnstyledButton>
  );
}

export default FramingSegment;
